import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Ban } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const AccountDeactivated = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center space-y-4 pb-6">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Ban className="w-8 h-8 text-red-600" />
          </div>
          <div>
            <CardTitle className="text-2xl font-bold text-gray-900">
              Account Deactivated
            </CardTitle>
            <CardDescription className="mt-2 text-base">
              Your account has been temporarily deactivated
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-4 space-y-3">
            <p className="text-sm text-gray-700 leading-relaxed">
              Your account has been deactivated by an administrator. You no longer have access to the application at this time.
            </p>
            <p className="text-sm text-gray-700 leading-relaxed">
              If you believe this is a mistake or would like to discuss reactivating your account, please contact support.
            </p>
          </div>

          <div className="pt-2">
            <Button
              onClick={handleSignOut}
              className="w-full"
              size="lg"
            >
              Sign Out
            </Button>
          </div>

          <div className="text-center">
            <a
              href="mailto:info@healthfq.com"
              className="text-sm text-primary hover:underline"
            >
              Contact Support
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccountDeactivated;
